import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AgreementCheckboxInput } from './agreement-checkbox.model';
import { ValidatorMessageModel } from '../form/form-helpers/validation/validator-message.model';

@Component({
  selector: 'app-agreement-checkbox',
  templateUrl: './agreement-checkbox.component.html',
  styles: [],
})
export class AgreementCheckboxComponent implements OnInit {
  @Input() item!: AgreementCheckboxInput;
  @ViewChild('checkboxInput') child: any;
  checked = false;

  prefix = 'agreementCheckbox.';

  validationMessage = {
    message: this.prefix + 'validators.agreement',
    value: '',
  } as ValidatorMessageModel;

  showValidation = false;

  constructor() {}

  ngOnInit(): void {}

  toggleCheckbox(checkbox: any) {
    this.checked = checkbox.target.checked;
    this.validate();
  }

  validate(): boolean {
    if (!this.checked) {
      this.showValidation = true;
    } else {
      this.showValidation = false;
    }

    return this.checked;
  }
}
